import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  id: "notificationFilterListViewPane",
  class: "scroll-top grid-listing"
}
const _hoisted_2 = { class: "right-container-padding" }
const _hoisted_3 = { class: "right-container-nav" }
const _hoisted_4 = { class: "width50" }
const _hoisted_5 = { class: "main-heading primary-heading" }
const _hoisted_6 = {
  key: 0,
  class: "empty-div display-flex align-items-center justify-content-center"
}
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = {
  key: 1,
  class: "margin-top-40"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NotificationFilterEditPane = _resolveComponent("NotificationFilterEditPane")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", {
            class: _normalizeClass({'width25' : !_ctx.isMobileView})
          }, [
            _createElementVNode("button", {
              class: "btn btn-secondary btn-size-default",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.CloseNotificationFilterListView()))
            }, _toDisplayString(_ctx.$t("Button.Close")), 1)
          ], 2),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$t("Dialogue.Filter.ManageFilter")), 1)
          ]),
          _cache[2] || (_cache[2] = _createElementVNode("div", { class: "add-btn-position" }, null, -1))
        ]),
        (_ctx.ShowEmptyFilterScreen())
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createElementVNode("h2", null, [
                _createElementVNode("span", {
                  class: "font-weight-100",
                  innerHTML: _ctx.$t('Dialogue.Filter.EmptyPlaceholderText')
                }, null, 8, _hoisted_7)
              ])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_8, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.localFiltersData, (item) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: item,
                  class: "margin-top-20"
                }, [
                  _createVNode(_component_NotificationFilterEditPane, {
                    "selected-filter-item": item,
                    onEditFilterItem: _cache[1] || (_cache[1] = ($event: any) => (_ctx.EditFilter($event)))
                  }, null, 8, ["selected-filter-item"])
                ]))
              }), 128))
            ]))
      ])
    ])
  ]))
}